export const userRegistrationInputForm = {
    title: 'ユーザ情報入力',
    selectPlaceholder: '選択してください',
    lastName: '姓（ローマ字）',
    lastNamePlaceholder: '姓を入力',
    firstName: '名（ローマ字）',
    firstNamePlaceholder: '名を入力',
    jobTitle: 'Title',
    organization: 'Organization Unit',
    email: 'メールアドレス',
    emailPlaceholder: 'example@pwc.com',
    comment: '備考',
    back: '戻る',
    submit: '登録',
    confirmTitle: '登録内容の確認',
    confirmMessage: '以下の内容で登録します。よろしいですか？',
    confirm: '登録する',
    cancel: 'キャンセル',
    errorRequired: '必須項目です',
    errorAlphabetOnly: '半角英字のみで入力してください',
    errorEmailInvalid: 'メールアドレスの形式が正しくありません',
    errorEmailDomain: '@pwc.comドメインのメールアドレスを入力してください',
    errorEmailDuplicate: 'このメールアドレスは既に登録されています',
    errorSubmitFailed: '登録に失敗しました。サポートまでお問い合わせください',
    errorMaxLength100: '100文字以内で入力してください',
    errorMaxLength200: '200文字以内で入力してください'
}
